import dayjs from "dayjs";
import {useStore} from "@/state/store";
import {toRaw} from 'vue'

let utc = require('dayjs/plugin/utc')
dayjs.extend(utc)

let dayOfYear = require('dayjs/plugin/dayOfYear')
dayjs.extend(dayOfYear)

let LocalizedFormat = require('dayjs/plugin/localizedFormat')
dayjs.extend(LocalizedFormat)

let duration = require('dayjs/plugin/duration')
dayjs.extend(duration)

import isoWeek from 'dayjs/plugin/isoWeek'
dayjs.extend(isoWeek)

import timezone from 'dayjs/plugin/timezone'
import {Back} from "@/helpers/back";
dayjs.extend(timezone)


export function deepNormalize(value) {
	const raw = toRaw(value)

	try {
		if (Array.isArray(raw)) return raw.map(deepNormalize)

		if (Object.prototype.toString.call(raw) === '[object Object]') {
			return Object.fromEntries(
				Object.entries(raw).map(([key, val]) => [key, deepNormalize(val)])
			)
		}
	} catch (r) {
		console.log(r)
	}

	return raw
}

export function toTimezone(dt, format = 'DD.MM.YYYY HH:mm:ss', tz = 'Europe/Moscow') {
  return dayjs(dt).tz(tz).format(format)
}

export function isl(key, store = null) {
	if(!store) store = useStore()
	return store.isLoading(key)
}

export function textToClipboard(text, onSuccess, onFail) {
	navigator.clipboard.writeText(text)
	  .then(onSuccess)
	  .catch(onFail);
}

export function formatBytes(bytes, decimals = 2) {
  if (bytes === 0) return '0 Б'
  const k = 1024
  const sizes = ['Б', 'КБ', 'МБ', 'ГБ', 'ТБ']
  const i = Math.floor(Math.log(bytes) / Math.log(k))
  return parseFloat((bytes / Math.pow(k, i)).toFixed(decimals)) + ' ' + sizes[i]
}

export function isNumeric(str) {
	if (typeof str === 'number') return true
	if (typeof str != "string") return false
	return !isNaN(str) && !isNaN(parseFloat(str))
}

export function dec(v, dec, drop_zeros = true) {
	v = v === undefined || v === ""  || v === null || isNaN(v) ? 0 : parseFloat(v)
	dec = dec === undefined  || dec === null || isNaN(dec) ? 0 : parseFloat(dec)
	if(dec < 0) dec = 0
	else if(dec > 19) dec = 19
	let res = prettyFloat(v.toFixed(dec))
	res = drop_zeros && dec > 0 ? res.replace(/\.?0*$/,'') : res
	return res
}

/***
 * Универсальная функция форматирования чисел, чтобы не городить dec(... конструкции
 * "dec:2:111.0:%" - е задано третье - то это от чего считать процент, 4 поле - что выводить в сл %, те выводить значок или нет
 * "dec:0"
 */
export function frmt(val, style = "dec:2:111.0") {
	let ret = val
	let s = style.split(":")
	if(s[0] === "dec") {
		let from_dot = parseInt(s[1])
		if(s.length === 2) ret = dec(val, from_dot, false)
		else {
			ret = dec(val * 100 / parseFloat(s[2]), from_dot, false )
			if(s[3]) ret += s[3]
		}
	}

	return  ret
}

export function dec_up(val, decimals_ = 2, pretty = false) {

	// return val ? parseFloat(val.toFixed(decimals)) : 0
	if (val === null || typeof val === 'undefined' || isNaN(val)) return 0
	if (typeof val === "string") val = parseFloat(val)
    let decimals = Math.pow(10, decimals_);
	let r =Math.round(val * decimals) / decimals_
	if (pretty) r = prettyFloat(r)
	return r
}


export function prettyFloat(v) {
	// пробела между тысячами
    const n = String(v), p = n.indexOf('.')
    return n.replace(
        /\d(?=(?:\d{3})+(?:\.|$))/g,
        (m, i) => p < 0 || i < p ? `${m} ` : m
    )
}

export function generateRandomTimeToday(format = 'DD.MM.YYYY HH:mm:ss') {
	const now = dayjs();
	const startOfDay = now.startOf('day');

	// Кол-во секунд от начала дня до текущего момента
	const secondsSinceStart = now.diff(startOfDay, 'second');
	// Случайное кол-во секунд в пределах сегодняшнего дня до текущего времени
	const randomSeconds = Math.floor(Math.random() * secondsSinceStart);
	const randomTime = startOfDay.add(randomSeconds, 'second');
	return randomTime.format(format);
}


export function generateRandomDtInPeriod(fromDt, toDt, format = 'DD.MM.YYYY HH:mm:ss') {
	const djFromDt = dayjs(fromDt)
	const djToDt = dayjs(toDt)
	const secondsSinceStart = djToDt.diff(djFromDt, 'second');
	// Случайное кол-во секунд в пределах сегодняшнего дня до текущего времени
	const randomSeconds = Math.floor(Math.random() * secondsSinceStart);
	const randomTime = djFromDt.add(randomSeconds, 'second');
	return randomTime.format(format);
}

export function dateDiffNow(dold) {
	return dateDiff(dayjs.utc(), dold)
}

export function dateDiff(dnew, dold) {
	// return ts in ms
	return dayjs.duration(dayjs(dnew).diff(dold))
}

export function prettyDt(dt, format="DD.MM.YYYY HH:mm:ss", utc = true, target_tz = 'Europe/Moscow') {
	// https://day.js.org/docs/en/display/format
	if (utc)  return dayjs.utc(dt).tz(target_tz).format(format)
	return dayjs(dt).tz(target_tz).format(format)
}

export function prettyDiffTs(ts_ms) {
	return new Date(ts_ms).toISOString().substring(11, 16)
}

export function durationSecToDt(sec) {
	return dayjs.duration(sec*1000)
}

export function timestampToDt(ts) {
	return dayjs.utc(ts)
}

export function now(ts) {
	return new Date()
}

export function parseStrToDt(str_dt, tz = 'Europe/Moscow') {
	try {
		// return new Date(Date.parse(str_dt))
		return dayjs.utc(str_dt).tz(tz, true).toDate();
	} catch (e) {
		// console.log(`parseStrToDt err ${str_dt} isnt a date`)
	}
}

export function nowUtc() {
	return dayjs.utc()
}

export function nowTz(tz = 'Europe/Moscow') {
	return dayjs().tz(tz)
}

export function now_tz_dt(tz = 'Europe/Moscow') {
	return dayjs().tz(tz).toDate()
}

export function to_tz(v, tz = 'Europe/Moscow') {
	return dayjs(v[0]).tz(tz).toDate()
}

export function makeDtByOffset(dt, offset, offset_period="day") {
	// Создаю дату (день, час, неделю) относительно базовой
	offset = Math.abs(offset)
	return  offset > 0 ? dt.subtract(offset, offset_period) : dt.add(offset, offset_period)
}

export function strDtToPrettyDt(str_dt, format="LLL") {
	return prettyDt(parseStrToDt(str_dt), format)
}

export function zeroPad(num, places) {
  let zero = places - num.toString().length + 1;
  return Array(+(zero > 0 && zero)).join("0") + num;
}

export function getRandomArrayItem(array) {
  return array[Math.floor(Math.random() * array.length)];
}

export function dateStartOf(period, from_ = null) {
	if(!from_) from_ = dayjs().tz('Europe/Moscow');
	if(!from_) from_ = nowUtc()
	return from_.startOf(period) // isoWeek
}

export function dateEndOf(period, from_ = null) {
	if(!from_) from_ = dayjs().tz('Europe/Moscow');
	if(!from_) from_ = nowUtc();
	return from_.endOf(period) // isoWeek
}

export function isMidnight(dt)  {
	return dt.getHours() === 0 && dt.getMinutes() === 0 && dt.getSeconds() === 0
}

export function nowMinus({ days = 0, hours = 0, minutes = 0, seconds = 0, from_ = null } = {}) {
	if(!from_) from_ = dayjs().tz("Europe/Moscow");
	if (days) from_ = from_.subtract(days, 'day')
	if (hours) from_ = from_.subtract(hours, 'hour')
	if (minutes) from_ = from_.subtract(minutes, 'minute')
	if (seconds) from_ = from_.subtract(seconds, 'second')
	return from_
}

export const tg_username = (tg) => {
  const value = String(tg ?? "").trim()
  if (!value) return ""

  // Убираем префиксы вида https://t.me/, http://t.me/, t.me/, @
  const raw = value
    .replace(/^https?:\/\/(www\.)?t\.me\//i, "")
    .replace(/^(www\.)?t\.me\//i, "")
    .replace(/^@/, "")
    .trim()

  // Берем только username (без /, ?, #)
  const username = raw.split(/[/?#]/)[0]
  if (!username) return ""

  return username
}

export function generateRandomString(length) {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    for (let i = 0; i < length; i++) {
        result += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return result;
}

export function generateRandomPhone(prefix = '907') {
  // Приводим prefix к цифрам и оставляем часть после стартовой "7"/"8", если передали номер целиком.
  let normalizedPrefix = String(prefix ?? '')
    .replace(/\D/g, '')
    .replace(/^[78]/, '')

  // После "7" в российском номере доступно 10 цифр.
  if (normalizedPrefix.length > 10) normalizedPrefix = normalizedPrefix.slice(0, 10)

  // Генерируем недостающий хвост до полной длины номера (11 цифр).
  const tailLength = 10 - normalizedPrefix.length
  let tail = ''
  for (let i = 0; i < tailLength; i++) {
    tail += Math.floor(Math.random() * 10)
  }

  // Итоговый формат всегда начинается с "7".
  return `7${normalizedPrefix}${tail}`
}

export function getHost(urlStr) {
  try {
    return new URL(urlStr).host;
  } catch (e) {
    return null;
  }
}

export function cleanObject(obj) {
  return Object.fromEntries(
    Object.entries(obj).filter(([_, v]) => v !== null && v !== undefined && v !== '')
  )
}

export function syncObjects(target, source) {
	// Для присваиваниям создержимого нового объекта, без уничножения экз оригинала
	// для сохранения реактивности

	try {
		// Удаляем ключи из target, которых нет в source
		for (const key in target) {
			if (Object.prototype.hasOwnProperty.call(target, key) && !Object.prototype.hasOwnProperty.call(source, key)) {
				delete target[key];
			}
		}

		// Копируем/обновляем ключи из source в target
		Object.assign(target, source);
	} catch (e) {}
}

export function setPeriod(v) {
	/**
	 * Конвертит массив дат в строку с таймштампами  12121212-98459465914 для передачи в бэк
	 */
	if (!v || v.length <= 1) return null
	// даты передавай всегда 00:00 - на бэке привожу  + timedelta(hours=24)
	v = dayjs(v[0]).utc(true).hour(0).minute(0).unix() + '-' + dayjs(v[1]).utc(true).hour(0).minute(0).unix()
	return v
}

export function clearFilters(filters) {
	if (filters) {
		Object.entries(filters).forEach(([key, val]) => {
			if (/^(like_|filter_|range_|period)/.test(key)) {
				filters[key] = key.startsWith("period") ? null : "";
			}
		});
	}

}

export function cleanUrl(url) {
	if (!url) return url;
	return url.endsWith('/') ? url.slice(0, -1) : url;
}



export function fastHash(obj) {
  function canonicalize(v) {
    if (v === null) return 'null';
    if (v === undefined) return 'undefined';
    if (typeof v === 'number') return `num:${isFinite(v) ? v : String(v)}`;
    if (typeof v === 'boolean') return `bool:${v}`;
    if (typeof v === 'string') return `str:${v}`;
    if (v instanceof Date) return `date:${v.toISOString()}`;
    if (Array.isArray(v)) {
      return '[' + v.map(canonicalize).join(',') + ']';
    }
    if (typeof v === 'object') {
      const keys = Object.keys(v).sort();
      return '{' + keys.map(k => `${JSON.stringify(k)}:${canonicalize(v[k])}`).join(',') + '}';
    }
    return `unknown:${String(v)}`;
  }

  const s = canonicalize(obj);

  // djb2-like 32-bit unsigned hash
  let hash = 5381;
  for (let i = 0; i < s.length; i++) {
    hash = ((hash << 5) + hash) ^ s.charCodeAt(i); // hash * 33 ^ ch
  }
  return hash >>> 0;
}

export function prettyRole(role) {
	const pretties = {'admin': 'Админ', 'manager': 'Менеджер', 'customer': 'Вебмастер', }
	return pretties[role] || role || ''
}

export function getValueByLabel(labels, label, deault_ = null) {
	// [{label: "WMZ", value: "wmz"}, {label: "USDT", value: "usdt"}, {label: "Карта", value: "card"}, {label: "СБП", value: "sbp"}, ]
	 if (!Array.isArray(labels)) return deault_;
	 const found = labels.find(item => item.label === label);
	 return found ? found.value : deault_;
}

export function getLabelByValue(labels, value, deault_ = null) {
	// [{label: "WMZ", value: "wmz"}, {label: "USDT", value: "usdt"}, {label: "Карта", value: "card"}, {label: "СБП", value: "sbp"}, ]
	 if (!Array.isArray(labels)) return deault_;
	 const found = labels.find(item => item.value === value);
	 return found ? found.label : deault_;
}

export async function copyToClipboard(value, store = null) {
  try {
    await navigator.clipboard.writeText(String(value));
	  if (store)
		  store.addMessage({
		  	"message": `Скопировано: ${value}`,
		  	"type": "success"
		})
  } catch (err) {
    console.error('Failed to copy: ', err);
  }
}

export function weekNumByDate(dt) {
	let weekNum = null
	if (dt instanceof Date) {
		const d = dayjs(dt)
		weekNum = parseInt(`${d.isoWeekYear()}${String(d.isoWeek()).padStart(2, '0')}`)
	}
	return weekNum
}

export function weekPeriodByWeeknum(weeknum) {
	/**
	 * Передаю номер недели в формате 202601 (int)
	 * на выходе получаю массив из 2х dayjs объектов
	 * 1й - начало недели
	 * 2й - конец недели
	 *
	 */
	 const str = String(weeknum)
	 const year = parseInt(str.slice(0, 4))
	 const week = parseInt(str.slice(4))
	 const start = dayjs().isoWeekYear(year).isoWeek(week).startOf('isoWeek')
	 const end = dayjs().isoWeekYear(year).isoWeek(week).endOf('isoWeek')
	 return [start, end]

}

export function loadHdeChat(store) {
	/**
	 * Загрузка виджета чата от HDE после получения юзера,
	 * чтобы подгружать его логин в поле
	 * https://support.helpdeskeddy.com/ru/knowledge_base/art/409/cat/67/onlajn-chat
	 */
    if (document.getElementById('hde-contact-widget')) return

	new Back("users/hde-session", 'post')
		.run(r => {
			const k = r?.data ?? null
			if(!k) return
			// const email = user?.login.indexOf("@") > 0 ? user?.login: user?.login + "@cbill.bigtime.now"

		    const script = document.createElement('script')
			script.src = '//cdn5.helpdeskeddy.com//js/contact-widget.js'
			script.id = 'hde-contact-widget'
			script.defer = true
			script.setAttribute('data-assets-host', '//cdn5.helpdeskeddy.com/')
			script.setAttribute('data-host', 'dreams.helpdeskeddy.com')
			script.setAttribute('data-lang', 'ru')
			script.setAttribute('data-id', k)
			// script.setAttribute('data-user-email', email)
			// script.setAttribute('data-comment', `id=${user?.id}, name=${user?.name}`)

			document.body.appendChild(script)
		})

}